import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-contact-overlay',
  templateUrl: './contact-overlay.component.html',
  styleUrls: ['./contact-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactOverlayComponent {
  @Input() public asPopup = false;
  @Input() public showOverlay = false;
  @Output() public overlayClosed = new EventEmitter<void>();
  public animateOut = false;

  public onAnimationEnd(animation: AnimationEvent): void {
    if (animation.animationName.endsWith('slide-to-bottom')) {
      this.overlayClosed.emit();
      this.animateOut = false;
    }
  }
}
